import { Theme } from '@emotion/react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { OfferTarget } from '../../../sic-lib/enums/OfferTarget';
import { MinimalFooter } from './MinimalFooter';

interface Props {
    children: JSX.Element | JSX.Element[];
    target?: OfferTarget;
}

export function MinimalPageLayout({ children, target = OfferTarget.SIC }: Props) {
    const { classes } = useStyles();

    return (
        <Grid
            container
            className={classes.root}
            style={{
                backgroundImage: `url('/${
                    target !== OfferTarget.SIC ? 'pagetitle-bg.png' : 'banner-bg-8.png'
                }')`,
            }}
        >
            <Grid
                container
                item
                justifyContent="center"
                flexDirection="column"
                flexWrap="nowrap"
                alignItems="center"
                className={classes.centeredWrapper}
            >
                {children}
                <MinimalFooter />
            </Grid>
        </Grid>
    );
}
const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        width: '100%',
        minWidth: '100vw',
        height: '100%',
        minHeight: '100vh',
        backgroundColor: '#0e2255',
        backgroundImage: `url('/pagetitle-bg.png')`,
        backgroundSize: 'cover',
        padding: '1rem',
    },
    centeredWrapper: {
        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
        // width: '100%',
        // minWidth: 'inherit',
        // height: '100%',
        // minHeight: 'inherit',
    },
}));
